import { useTranslation } from "react-i18next";
import { useChatScroll } from "../../hooks/useChatScroll";
import ChatMessagesGroup from "./ChatMessagesGroup";

export type ChatMessage = {
  message: string;
  direction: "sent" | "received";
  date: Date;
};
export type ChatMessagesGroup = {
  [date: string]: ChatMessage[];
};

type ChatMessagesListProps = {
  messageGroups: ChatMessagesGroup;
};

export default function ChatMessagesList(props: ChatMessagesListProps) {
  const { messageGroups } = props;
  const LocalBasePath = "page.chat";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const messagesContainerRef = useChatScroll(messageGroups);

  if (Object.keys(messageGroups).length === 0) {
    return (
      <div className="w-full h-full flex py-4 flex-col justify-end items-center pb-[155px]">
        <p className="text-gray-400 text-sm">{t("sendMessage")}</p>
      </div>
    );
  }

  return (
    <div className="w-full  h-full">
      {Object.keys(messageGroups).map((date: string) => (
        <ChatMessagesGroup date={date} messages={messageGroups[date]} />
      ))}
      <div
        ref={messagesContainerRef as React.MutableRefObject<HTMLDivElement>}
      />
    </div>
  );
}
